/* Instagram CTA section — carousel mode. Native scroll-snap track (same mechanics as the New In
 * super-scroll-carousel), progress bar + prev/next round buttons below, disabled at the ends.
 * External + defer per project rule. build=2026-09-19-v4-progress-ratio */
(function () {
  console.log('[ig-carousel] build=2026-09-19-v4-progress-ratio');

  function init(root) {
    if (root.dataset.igInit === '1') return;
    root.dataset.igInit = '1';

    var track = root.querySelector('.ig-carousel-track');
    var prev = root.querySelector('.ig-carousel-nav--prev');
    var next = root.querySelector('.ig-carousel-nav--next');
    var fill = root.querySelector('.ig-carousel-progress-fill');
    if (!track) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('.ig-carousel-card'));
    var total = cards.length;
    if (!total) return;

    function gap() {
      var cs = getComputedStyle(track);
      return parseFloat(cs.columnGap || cs.gap || '0') || 0;
    }
    function perView() {
      return window.innerWidth >= 750 ? parseInt(root.dataset.perView || '3', 10) : 1;
    }
    function step() { return (cards[0].offsetWidth + gap()) * perView(); }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev && next) {
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= max - 1;
      }
      if (fill) {
        // Progress = how much of the track has been revealed (visible right edge / full width).
        // Uses scroll geometry only — no card-width maths, so it can never go NaN in the editor.
        var pct = track.scrollWidth > 0 ? ((track.scrollLeft + track.clientWidth) / track.scrollWidth) * 100 : 0;
        if (!isFinite(pct)) pct = 0;
        pct = Math.max(0, Math.min(100, pct));
        fill.style.width = pct.toFixed(2) + '%';
      }
    }

    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); track.scrollBy({ left: step(), behavior: 'smooth' }); });

    var t;
    track.addEventListener('scroll', function () { update(); clearTimeout(t); t = setTimeout(update, 120); }, { passive: true });
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(update, 200); });
    update();
    setTimeout(update, 100); // after images/layout settle
    window.addEventListener('load', update);
  }

  function scan() { document.querySelectorAll('.ig-carousel[data-per-view]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan); // theme editor re-renders
})();
